import { createSlice } from '@reduxjs/toolkit';

import { removeState } from 'Utilities/LocalStorage';

import { TOKEN_SESSION_KEY } from '../CONSTANTS';
const INITIAL_STATE = () => {
	return {
		loading: false,
		error: [] as string[],
		title: 'Dashboard' as string,
		listUpdate: false,
	};
};

type IINITIAL_STATE = ReturnType<typeof INITIAL_STATE>;

interface IACTION<T = unknown> {
	type: string | symbol;
	payload: T;
}

const AuthSlice = createSlice({
	name: 'auth',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = [];
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
		SET_TITLE: (state, action: IACTION<string>) => {
			state.title = action.payload;
		},
		REFRESH_LIST: (state) => {
			state.listUpdate = !state.listUpdate;
		},
		LOG_OUT: (state) => {
			setTimeout(() => {
				window.location.href = '/logout';
			}, 500);
			removeState(TOKEN_SESSION_KEY);
			Object.assign(state, INITIAL_STATE());
		},
	},
});

export const { REFRESH_LIST } = AuthSlice.actions;

export default AuthSlice;
